import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getRegistrationByUserId } from '../../Api/Registration';

interface Props {
    url: string;
    isDarkMode: boolean;
}
interface CourseType {
    id: string;
    name: string;
    durationType: string;
    fees: number;
}

interface Course {
    id: string;
    name: string;
}

interface Registration {
    id: string;
    courseOfferingId: string;
    courseType: CourseType;
    course: Course;
    userId: string;
    userName: string;
    duration: number;
    timeZone: string;
    timeRange: string;
    status: string;
    fee : number;
    updatedBy: string;
    updatedOn: string;
}

export function ShowRegistration({ url, isDarkMode }: Props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const [RegData, setRegData] = useState<Registration[]>([]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await getRegistrationByUserId(url) as Registration[];
            console.log(response);
            setRegData(response);
            setLoading(false);
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch data");
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formatDate = (utcString: string) => {
        const utcDate = new Date(utcString);
        const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
        return localDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    return (
        <div className={`py-14 ${isDarkMode ? 'bg-globalBg text-white' : 'bg-white text-gray-900'}`}>
            <div className={`lg:mx-[320px] md:mx-0 rounded-lg shadow-md overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <div className={`p-6 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                    <h2 className="text-2xl font-bold text-blue-600">Enrolled Courses</h2>
                </div>
                <div className="relative p-6">
                    <div className="overflow-x-auto">
                        <table className="min-w-full table-auto border-collapse ">
                            <thead>
                                <tr className={`${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-50 text-black'}`}>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">User Name</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Course Name</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Course Type</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Status</th>
                                    <th className="px-5 py-3 text-right text-sm font-medium  tracking-wider">Fee</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Duration</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Time Range</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Registered On</th>
                                </tr>
                            </thead>
                            <tbody className={`${isDarkMode ? 'bg-gray-800 text-gray-200' : 'bg-white text-gray-900'} divide-y ${isDarkMode ? 'divide-gray-700' : 'divide-gray-200'}`}>
                                {RegData.map((item) => (
                                    <tr key={item.id} className={isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.userName}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.course.name}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.courseType.name}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.status}</td>
                                        <td className="px-5 py-4 whitespace-nowrap text-right">
                                            ₹{(item.fee || 0).toLocaleString("en-IN")}
                                        </td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.duration} Hour</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.timeRange}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{formatDate(item.updatedOn)}</td>
                                    </tr>
                                ))}
                                {loading && (
                                    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
                                        <div className="w-12 h-12 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                                    </div>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={`px-6 py-4 border-t flex justify-between items-center ${isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50'}`}>
                    <button
                        onClick={() => navigate('/Education/Fee')}
                        className={`px-4 py-2 rounded-md text-white ${isDarkMode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        Pay Fee
                    </button>
                </div>
            </div>
        </div>
    );
}
